import {
  getAllTables,
  getAllTablesSuccess,
  getAllResourceGroup,
  getAllResourceGroupSuccess,
  getAllResources,
  getAllResourcesSuccess,
  getTableOrdersData,
  getTableOrdersDataSuccess,
  transferKOT,
  transferKOTSuccess,
  transferItem,
  transferItemSuccess,
  transferTable,
  transferTableSuccess,
  cancelKOT,
  cancelKOTSuccess,
  cancelOrder,
  cancelOrderSuccess,
  deleteItem,
  deleteItemSuccess,
  splitItems,
  splitItemsSuccess,
  splitOrders,
  splitOrdersSuccess,
  closeOrder,
  closeOrderSuccess,
  print,
  printSuccess,
  getUsers,
  getUsersSuccess,
  sendDigiatlBillViaEmail,
  sendDigitalBillViaEmailSuccess,
  sendDigiatlBillViaSMS,
  sendDigitalBillViaSMSSuccess,
  sendDigiatlBillViaWA,
  sendDigitalBillViaWASuccess,
  fetchPrinter,
  fetchPrinterSuccess,
  printKOTSlice,
  printKOTSuccess,
  allTablesCallComplete,
  allResourcesCallComplete,
  allResourceGroupCallComplete,
  printersCallComplete,
  usersCallComplete,
  calculateSaleFromBE,
} from "../../slices/TableViewSlice";
import { takeEvery, put, select } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import store from "../..";
import { saveOthersOffline, updateSyncedSale } from "../../../helpers/OfflineHelper";
import { backendErrorMap as backend_errormap } from "../../../utils/backendErrors";
import {
  ORDER_CLOSED, REST_SALE_ITEMS_ON_HOLD, REST_ORDER_IS_NOT_PROCESSED_ON_KDS,
  SALE_STATUS_TYPES, DISCOUNT_APPROVAL_STAGE,
} from "../../../utils/constants";
import { calculateSale, hasItemLeveErrors, isLastKOT, summarizeSaleData } from "../../../helpers/saleHelpers";
import { addDiscountApprovalData } from "../../slices/DiscountSlice";
import { removeAdhocTable, updateAdhocTables } from "../../../helpers/adhocTableHelpers";
import { updateDiscountApprovalState } from "../../../helpers/updateDiscountApprovalState";
import { updateNcApprovalState } from "../../../helpers/updateNcApprovalState";
import { clearAcceptedOrder, clearAcceptedOrderFromNotifications, preventCloseSale } from "../../../helpers/commonHelpers";
import { saveSaleData } from "../../slices/SaleSlice";
import { saveBackOrderShowModal } from "../../slices/CustomerSlice";
import { paymentSuccessPopup } from "../../slices/CheckoutSlice";
import { REST_SALE_BACK_ITEMS_NOT_PROCESSED, INSUFFICIENT_STOCK } from "../../../data/constants";
import { GA_CATEGORIES, GA_EVENTS } from "../../../data/gaConstants";
import { fireOrderPlacedEvent } from "../../../helpers/cartAuditHelper";
import { notifyError, notifySuccess, printSaleTickets, sendGTMEvent } from "../../../effects-bridge";

export * from "./shared";

/**
 * WEB variant of `redux-store/saga/tableView`. See `./shared.ts` for the split.
 *
 * ⚠️ **Four capabilities come from the EFFECTS BRIDGE**: `printSaleTickets`, `sendGTMEvent`,
 * `notifyError` and `notifySuccess`. Every `ToastNotifyError(` / `ToastNotifySuccess(` call site
 * became the bridge equivalent — the same functions this app wires at boot.
 *
 * ⚠️ **`store.getState()` stayed `store.getState()`** at 3 sites — the `store` it names is now core's own, imported from `../../index.desktop`; the app read the
 * store singleton directly. Same store, same values — the bridge is initialised at app boot
 * before any saga runs.
 *
 * ⚠️ `backendErrorMap` is imported UNDER ITS APP-SIDE ALIAS `backend_errormap` so the ~20 body
 * references are unchanged. Core exports one canonical name; the alias lives only here.
 */

function* fetchAllTables(action: any): any {
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.getAllTablesData(),
      skipGlobalLoader: action.payload?.skipGlobalLoader
    } as any);
    // console.log("response getAllTablesInfo: ", response);
    yield put(getAllTablesSuccess(response));
  } catch (error) {
    // console.log("error", error);
  } finally {
    yield put(allTablesCallComplete());
  }
}

function* fetchAllResources(action: any): any {
  // console.log("allResources");
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.getResource(),
      skipGlobalLoader: action.payload?.skipGlobalLoader
    } as any);
    // console.log("response getAllResourceInfo: ", response);
    yield put(getAllResourcesSuccess(response));
    yield saveOthersOffline({
      type: 'resource',
      items: response
    });
  } catch (error) {
    // console.log("error", error);
  } finally {
    yield put(allResourcesCallComplete());
  }
}

function* fetchAllResourceGroups(action: any): any {
  // console.log("allResourceGroups");
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.getResourceGroup(),
      skipGlobalLoader: action.payload
    } as any);
    // console.log("response getAllResourceGroupsInfo: ", response);
    yield put(getAllResourceGroupSuccess(response));
    yield saveOthersOffline({
      type: 'resourcegroup',
      items: response
    });
  } catch (error) {
    // console.log("error", error);
  } finally {
    yield put(allResourceGroupCallComplete());
  }
}

function* fetchTableOrdersData(action: any): any {
  let tableId = action.payload;
  // console.log("allTableOrdersData");
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.getTableOrders(tableId),
    } as any);
    updateDiscountApprovalState(response);
    updateNcApprovalState(response);
    yield put(getTableOrdersDataSuccess(response));
    yield put(saveSaleData(response[0]));
  } catch (error) {
    // console.log("error", error);
  }
}

function* transferKOTFunction(action: any): any {
  let payload = action.payload;
  // console.log("TransferKOT");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.tranferKOT(),
      data: payload,
    } as any);
    // console.log("response transferKOT: ", response);
    yield put(transferKOTSuccess(response));
    payload.callback && payload.callback(response);
    printSaleTickets(response?.toSale, response?.toSale?.tickets)
  } catch (error) {
    // console.log("error", error);
  }
}

function* transferItemFunction(action: any): any {
  let payload = action.payload;
  // console.log("TransferItem");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.tranferItem(),
      data: payload,
    } as any);
    if (response && !response?.code) {
      //Add the from sale and to sale.
      if (response?.fromSale && !response.fromSale?.operation) {
        updateSyncedSale(response.fromSale);
      }
      if (response?.toSale && !response.toSale.operation) {
        updateSyncedSale(response.toSale);
      }
    }
    console.log("response transferItem: ", response?.toSale);
    yield put(transferItemSuccess(response));
    payload.callback && payload.callback(response);
    printSaleTickets(response?.toSale, response?.toSale?.tickets)
  } catch (error) {
    // console.log("error", error);
  }
}

function* transferTableFunction(action: any): any {
  let payload = action.payload?.dataToSend;
  let callback = action.payload?.callback;
  // console.log("TransferTable");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.transferTable(),
      data: payload,
    } as any);
    if (response && !response?.code && response?.sale && !response.operation) {
      updateSyncedSale(response.sale);
    }
    console.log("response transferTable: ", response.sale);
    yield put(transferTableSuccess(response));
    printSaleTickets(response?.sale, response?.sale?.tickets);
    callback(response);
  } catch (error) {
    // console.log("error", error);
  }
}

function* cancelKOTFunction(action: any): any {
  let payload = action.payload?.payload;
  let mid = action.payload?.mid;
  let ticketNumber = action.payload?.ticketNumber;
  let callback = action.payload?.callback;
  // console.log("cancelKOT");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.cancelKOT(mid, ticketNumber),
      data: payload,
    } as any);
    // console.log("response cancelKOT: ", response);
    yield put(cancelKOTSuccess(response));
    if (!response?.code && Object.keys(response)?.length) {
      if (isLastKOT(response?.tickets)) {
        callback();
      }
      printSaleTickets(response, response?.tickets);
    }

  } catch (error) {
    // console.log("error", error);
  }
}

function* cancelOrderFunction(action: any): any {
  let payload = {
    ...(action?.payload?.reason || {}),
    ...(action?.payload?.returnData || {}),
  };
  let mid = action.payload.mid,
    newOnlineOrders = store.getState().notificationsStore?.newOnlineOrders;
  // console.log("cancelOrder");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.cancelOrder(mid),
      data: payload,
    } as any);
    if (response && !response?.code) {
      updateSyncedSale(response);
    }
    removeAdhocTable(response);
    // console.log("response cancelOrder: ", response);
    action?.payload?.callback && action?.payload?.callback();
    yield put(cancelOrderSuccess(response));
    if (action?.payload?.callback)
      action?.payload?.callback(response);
    if (!!newOnlineOrders?.length) {
      clearAcceptedOrderFromNotifications(mid);
    } else {
      clearAcceptedOrder(mid);
    }
    printSaleTickets(response, response?.tickets);
  } catch (error) {
    // console.log("error", error);
  }
}

function* handleDeleteItem(action: any): any {
  let payload = action.payload?.dataToSend;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.SALE.saveSale(),
      data: payload,
    } as any);
    // console.log("response deleteItem: ", response);
    yield put(deleteItemSuccess(response));
    printSaleTickets(response, response?.tickets)
  } catch (error) {
    // console.log("error", error);
  }
}

function* handleSplitItems(action: any): any {
  let payload = action.payload;
  // console.log("splitItem");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.SALE.saveSale(),
      data: payload?.dataToSend,
    } as any);
    if (response && !response?.code && !response?.operation) {
      updateSyncedSale(response);
    }
    // console.log("response splitItem: ", response);
    yield put(splitItemsSuccess(response));
    payload?.callback(response);
  } catch (error) {
    // console.log("error", error);
  }
}

function* handleSplitOrders(action: any): any {
  let payload = action.payload;
  // console.log("splitOrders");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.splitOrders(),
      data: payload,
    } as any);
    if (response && !response?.code && response?.splits?.length) {
      response.splits.forEach(function (sale: any) {
        if (!sale.operation) {
          updateSyncedSale(sale);
        }
      });
    }
    // console.log("response splitOrders: ", response);
    yield put(splitOrdersSuccess(response));
  } catch (error) {
    // console.log("error", error);
  }
}

function* handleCloseOrder(action: any): any {
  let payload = action.payload;
  console.log("CloseOrder", payload);
  if (preventCloseSale(payload?.dataToSend, { url: ENDPOINT.TABLEVIEW.closeOrder(), functionName: "handleCloseOrder" })) {
    return;
  }
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.closeOrder(),
      data: payload.dataToSend,
      hideLoader: false
    } as any);
    if (response?.code === REST_SALE_BACK_ITEMS_NOT_PROCESSED || response?.errors?.includes(INSUFFICIENT_STOCK)) {
      yield put(saveBackOrderShowModal(true))
    }
    if (
      response &&
      !!Object.keys(response)?.length &&
      !response?.errors?.length &&
      !response?.warnings?.length &&
      !response?.code &&
      !hasItemLeveErrors(response?.saleItems)
    ) {
      if (response?.saleStatus === SALE_STATUS_TYPES.CLOSED) {
        const saleSummary = summarizeSaleData(response);
        sendGTMEvent({
          eventName: GA_EVENTS.ORDER_COMPLETED,
          params: {
            category: GA_CATEGORIES.SALE,
            ...saleSummary,
            saleId: response?.mid
          }
        });

        // Fire ORDER_PLACED cart audit event
        fireOrderPlacedEvent(response?.mid, response?.billTotal || 0);

        yield put(paymentSuccessPopup(response));
      }
      if (!response.operation)
        updateSyncedSale(response);
    }
    if (response && payload.callback) {
      console.log("response closeOrder: ", response);
      payload.callback(response);
    }
    if (!response?.code && !response?.warnings?.length) {
      notifySuccess(ORDER_CLOSED);
      removeAdhocTable(response);
    }
    if (response?.code === REST_SALE_ITEMS_ON_HOLD || response?.code === REST_ORDER_IS_NOT_PROCESSED_ON_KDS) {
      notifyError((backend_errormap as any)?.[response?.code])
    }
    yield put(closeOrderSuccess(response));
  } catch (error) {
    // console.log("error", error);
  }
}

function* calculateSaleSaga(action: any): any {
  let payload = action.payload;
  console.log("Calculate sale", payload);
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.calculateSale,
      data: payload.dataToSend,
      hideLoader: false
    } as any);
    if (
      response &&
      !!Object.keys(response)?.length &&
      !response?.errors?.length &&
      !response?.warnings?.length &&
      !response?.code &&
      !hasItemLeveErrors(response?.saleItems)
    ) {
      if (!response.operation)
        yield updateSyncedSale(response);
    }
    let updatedSale;
    if (response && !response?.code) {
      updatedSale = calculateSale(response);
    } else if (response?.code === "REST_SALE_OPERATION_NOT_ALLOWED") {
      updatedSale = structuredClone(payload.dataToSend);
    }
    if (updatedSale) {
      yield put(saveSaleData(updatedSale));
    }
    if (updatedSale && payload.callback) {
      console.log("response calculateSale: ", updatedSale);
      payload.callback(updatedSale);
    }
  } catch (error) {
    console.log("error calculateSale: ", error);
  }
}

function* sendDigiatlBillViaEmailFunc(action: any): any {
  let mid = action.payload.mid;
  let email = action.payload.selectedContactNumber
  // console.log("sendDigitalBill");
  try {
    let response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.sendBillOnEmail(mid, email),
    } as any);
    if (Object.keys(response).length == 0) {
      response = {
        sent: true
      }
    }
    // console.log("response sendDigitalBill: ", response);
    action.payload?.callback(response)
    yield put(sendDigitalBillViaEmailSuccess(response));
  } catch (error) {
    // console.log("error", error);
  }
}

function* sendDigiatlBillViaSMSFunc(action: any): any {
  let payload = action.payload?.payload;
  let mid = action.payload?.mid
  // console.log("sendDigitalBill");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.sendBillOnSMS(mid),
      data: payload,
    } as any);
    // console.log("response sendDigitalBill: ", response);
    action.payload?.callback(response)
    yield put(sendDigitalBillViaSMSSuccess(response));
  } catch (error) {
    // console.log("error", error);
  }
}

function* sendDigiatlBillViaWAFunc(action: any): any {
  // debugger
  let payload = action.payload?.payload;
  let mid = action.payload?.mid
  // console.log("sendDigitalBill");
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.sendBillOnWhatsapp(mid),
      data: payload,
    } as any);
    // console.log("response sendDigitalBill: ", response);
    action.payload?.callback(response)
    yield put(sendDigitalBillViaWASuccess(response));
  } catch (error) {
    action.payload?.callback({});
    // console.log("error", error);
  }
}

function* printFunc(action: any): any {
  let payload = action.payload?.dataToSend,
    callback = action.payload?.callback;
  // console.log("print");
  try {
    const response = yield api.request({
      method: "POST",
      url: payload?.saleStatus === SALE_STATUS_TYPES.CLOSED ? ENDPOINT.TABLEVIEW.printClosed(payload?.mid) : ENDPOINT.TABLEVIEW.print(),
      data: payload,
      skipGlobalLoader: true
    } as any);
    if (response && !response?.code && !response.operation) {
      updateSyncedSale(response);
    }
    // console.log("response print: ", response);
    updateAdhocTables(response);
    yield put(printSuccess(response));
    callback && callback(response);
  } catch (error) {
    // console.log("error", error);
  }
}

function* fetchUsers(action: any): any {
  let payload = action.payload;
  // console.log("users");
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.users(),
      hideLoader: payload
    } as any);
    // console.log("response fetchUsers: ", response);
    if (!response?.code) {
      const branchId = yield select(state => state.businessStore?.businessData?.branchId);
      yield put(getUsersSuccess({allUsers: response, branchId}));
    }
  } catch (error) {
    // console.log("error", error);
  } finally {
    yield put(usersCallComplete());
  }
}

function* fetchPrinterFn(): any {
  // console.log("printers");
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.TABLEVIEW.getPrinters(),
    } as any);
    // console.log("response printers: ", response);
    yield put(fetchPrinterSuccess(response));
    yield saveOthersOffline({
      type: 'printer',
      items: response
    });
  } catch (error) {
    // console.log("error", error);
  } finally {
    yield put(printersCallComplete());
  }
}

function* printerKOTFn(action: any): any {
  console.log("printKOTPayload", action.payload);
  let id = action.payload?.id
  let payload = {
    ticketInfos: action.payload?.ticketInfos
  }
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.TABLEVIEW.printKOTURL(id),
      data: payload,
      skipGlobalLoader: true
    } as any);
    if (response && !response?.code && !response.operation) {
      updateSyncedSale(response);
    }
    // console.log("response printers: ", response);
    updateAdhocTables(response);
    if (action.payload?.callback) {
      yield action.payload.callback(response);
    }
    yield put(printKOTSuccess(response));
  } catch (error) {
    if (action.payload?.errorCallback) {
      yield action.payload.errorCallback(error);
    }
    // console.log("error", error);
  }
}

export default function* root(): any {
  yield takeEvery(getAllTables.type, fetchAllTables);
  yield takeEvery(getAllResources.type, fetchAllResources);
  yield takeEvery(getAllResourceGroup.type, fetchAllResourceGroups);
  yield takeEvery(getTableOrdersData.type, fetchTableOrdersData);
  yield takeEvery(transferKOT.type, transferKOTFunction);
  yield takeEvery(transferItem.type, transferItemFunction);
  yield takeEvery(transferTable.type, transferTableFunction);
  yield takeEvery(cancelKOT.type, cancelKOTFunction);
  yield takeEvery(cancelOrder.type, cancelOrderFunction);
  yield takeEvery(deleteItem.type, handleDeleteItem);
  yield takeEvery(splitItems.type, handleSplitItems);
  yield takeEvery(splitOrders.type, handleSplitOrders);
  yield takeEvery(closeOrder.type, handleCloseOrder);
  yield takeEvery(calculateSaleFromBE.type, calculateSaleSaga);
  yield takeEvery(sendDigiatlBillViaEmail.type, sendDigiatlBillViaEmailFunc);
  yield takeEvery(sendDigiatlBillViaSMS.type, sendDigiatlBillViaSMSFunc);
  yield takeEvery(sendDigiatlBillViaWA.type, sendDigiatlBillViaWAFunc);
  yield takeEvery(print.type, printFunc);
  yield takeEvery(getUsers.type, fetchUsers)
  yield takeEvery(fetchPrinter.type, fetchPrinterFn)
  yield takeEvery(printKOTSlice.type, printerKOTFn)
}
